import { Button } from '@village/ui';
import { InputForm, MaskedInputForm, RadioForm } from 'components/fields';
import { FC, Fragment } from 'react';

import { GuardianCheckbox } from './guardian-checkbox';
import { StatesAutocomplete } from './states-autocomplete';
import * as Styled from './styles';

interface Props {
    /**
     * Disable all the fields of the form and the submit button
     */
    disabled?: boolean;
}

const PatientInformationFormInputs: FC<Props> = ({ disabled }) => {
    return (
        <Fragment>
            <Styled.FieldsGroup>
                <Styled.GroupTitle type="sub3">1. Patient information</Styled.GroupTitle>
                <Styled.InlineFields $template="1fr 1fr">
                    <InputForm label="First name (legal)" name="firstName" fullWidth={true} disabled={disabled} />
                    <InputForm label="Last name (legal)" name="lastName" fullWidth={true} disabled={disabled} />
                </Styled.InlineFields>
                <Styled.InlineFields $template="1fr 1fr">
                    <MaskedInputForm
                        name="dateOfBirth"
                        mask="00/00/0000"
                        label="Date of birth"
                        placeholder="MM/DD/YYYY"
                        fullWidth={true}
                        eager={true}
                        disabled={disabled}
                    />
                </Styled.InlineFields>
                <Styled.InlineFields $template="1fr">
                    <RadioForm
                        id="select-sex"
                        label="Sex (legal)"
                        name="sex"
                        options={[
                            { value: 'F', label: 'Female' },
                            { value: 'M', label: 'Male' },
                        ]}
                        disabled={disabled}
                    />
                </Styled.InlineFields>
            </Styled.FieldsGroup>
            <Styled.FieldsGroup>
                <Styled.GroupTitle type="sub3">2. Contact details</Styled.GroupTitle>
                <Styled.InlineFields $template="1fr">
                    <InputForm
                        label="Email address"
                        name="email"
                        fullWidth={true}
                        aria-label="Email"
                        type="email"
                        disabled={disabled}
                    />
                </Styled.InlineFields>
                <Styled.InlineFields $template="1fr 1fr">
                    <MaskedInputForm
                        name="phoneNumber"
                        type="tel"
                        mask="(000) 000-0000"
                        label="Phone number"
                        placeholder="(___) ___-____"
                        fullWidth={true}
                        eager={true}
                        disabled={disabled}
                    />
                </Styled.InlineFields>
                <Styled.InlineFields $template="1fr">
                    <RadioForm
                        id="select-phone-type"
                        label="Phone type"
                        name="phoneType"
                        options={[
                            { value: 'Mobile', label: 'Mobile' },
                            { value: 'Home', label: 'Home' },
                        ]}
                        disabled={disabled}
                    />
                </Styled.InlineFields>
            </Styled.FieldsGroup>
            <Styled.FieldsGroup>
                <Styled.GroupTitle type="sub3">3. Home address</Styled.GroupTitle>
                <Styled.InlineFields $template="1fr 1fr">
                    <InputForm label="Address" placeholder="Address" name="address" fullWidth={true} disabled={disabled} />
                    <InputForm
                        label="Address line 2 (optional)"
                        placeholder="Apt, Suite, Unit, etc."
                        name="addressCount"
                        fullWidth={true}
                        disabled={disabled}
                    />
                </Styled.InlineFields>
                <Styled.InlineFields $template="1fr">
                    <InputForm label="City" placeholder="City" name="city" fullWidth={true} disabled={disabled} />
                </Styled.InlineFields>
                <Styled.InlineFields $template="1fr 1fr">
                    <StatesAutocomplete label="State" disabled={disabled} />
                    <InputForm
                        label="ZIP"
                        placeholder="Zip Code"
                        name="zip"
                        fullWidth={true}
                        type="number"
                        disabled={disabled}
                        aria-label="zip-code"
                        onWheel={(e) => e.currentTarget.blur()}
                    />
                </Styled.InlineFields>

                <GuardianCheckbox />
            </Styled.FieldsGroup>

            <Styled.SubmitButtonContainer>
                <Button disabled={disabled} fullWidth={true} type="submit" data-testid="button-review-details" formNoValidate>
                    Review details
                </Button>
            </Styled.SubmitButtonContainer>
        </Fragment>
    );
};

export { PatientInformationFormInputs };
